import { ProfileBases } from 'enums';
import { Message } from 'features/co-pilot/campaign-statistics/campaign-statistics-types';
import { OptionType } from 'features/ui/base-components/pai-auto-complete';

export interface ManualTag {
  _id: string;
  name: string;
  createDate: string;
}

export interface CampaignTag {
  name: string;
}

export interface Contact {
  _id: string;
  firstname: string;
  lastname: string;
  sex: string;
  companyName: string;
  occupation: string;
  email: string;
  profileId: string;
  translatedLinkedInProfile: string;
  phoneNumber?: string;
  address?: string;
  manualTags: ManualTag[];
  campaignTags: CampaignTag[];
  contactPersons: {
    fullName?: string;
    linkedInEmail?: string;
    contactDegree: number;
  }[];
  customField?: string[];
  contactDegree: number | string;
  createDate: Date;
  updateDate: Date;
  /**
   * Polite speech detection result.
   * true  -> formal ("Sie")
   * false -> informal ("du")
   * undefined -> not analysed yet
   */
  isPolite?: boolean;
  basis?: ProfileBases;
}

export interface InteractionHistory {
  campaignName: string;
  messages: Message[];
  createDate: Date;
}

export interface Filter {
  column: FilterColumns;
  operator: FilterOperatorsText | FilterOperatorsNumeric | FilterOperatorsDate;
  value: string | Date | number | OptionType;
  values?: string[] | OptionType[];
}

export enum FilterTypes {
  TEXT = 'text',
  NUMERIC = 'numeric',
  DATE = 'date',
  AUTOCOMPLETE = 'autocomplete',
}

export enum FilterLogics {
  AND = 'and',
  OR = 'or',
}

export enum FilterColumns {
  CREATE_DATE = 'create-date',
  CAMPAIGN_TAGS = 'campaign-tags',
  MANUAL_TAGS = 'manual-tags',
  CONTACT_DEGREE = 'contact-degree',
  COMPANY = 'company',
  FIRST_NAME = 'first-name',
  CONTACT_PERSON = 'contact-person',
}

export const filterColumnTypes = {
  [FilterColumns.CREATE_DATE]: FilterTypes.DATE,
  [FilterColumns.CAMPAIGN_TAGS]: FilterTypes.AUTOCOMPLETE,
  [FilterColumns.MANUAL_TAGS]: FilterTypes.AUTOCOMPLETE,
  [FilterColumns.CONTACT_DEGREE]: FilterTypes.NUMERIC,
  [FilterColumns.COMPANY]: FilterTypes.TEXT,
  [FilterColumns.FIRST_NAME]: FilterTypes.TEXT,
  [FilterColumns.CONTACT_PERSON]: FilterTypes.TEXT,
};

export enum FilterOperatorsText {
  EQUALS = 'equals',
  IS_NOT = 'is-not',
  CONTAINS = 'contains',
  STARTS_WITH = 'starts-with',
  ENDS_WITH = 'ends-with',
  IS_EMPTY = 'is-empty',
  IS_NOT_EMPTY = 'is-not-empty',
  IS_ANY_OF = 'is-any-of',
}

export enum FilterOperatorsNumeric {
  EQUAL = '=',
  NOT_EQUAL = '!=',
  GREATER_THAN = '>',
  GREATER_THAN_OR_EQUAL = '>=',
  SMALLER_THAN = '<',
  SMALLER_THAN_OR_EQUAL = '<=',
  IS_EMPTY = 'is-empty',
  IS_NOT_EMPTY = 'is-not-empty',
  IS_ANY_OF = 'is-any-of',
}

export enum FilterOperatorsDate {
  IS = 'is',
  IS_NOT = 'is-not',
  IS_AFTER = 'is-after',
  IS_ON_OR_AFTER = 'is-on-or-after',
  IS_BEFORE = 'is-before',
  IS_ON_OR_BEFORE = 'is-on-or-before',
}
